export default __webpack_public_path__ + "static/media/larvia-logo-dark.8fe7617a.png";